// firebase.js

import firebase from 'firebase/compat/app';
import 'firebase/compat/database';

const firebaseConfig = {
  apiKey: "AIzaSyCuJkQai2_U5kX28iTXqRtnnf6JTVk81AA",
  authDomain: "digital-oil-lamp-db.firebaseapp.com",
  databaseURL: "https://digital-oil-lamp-db-default-rtdb.firebaseio.com",
  projectId: "digital-oil-lamp-db",
  storageBucket: "digital-oil-lamp-db.firebasestorage.app",
  messagingSenderId: "956873545425",
  appId: "1:956873545425:web:cf11d5cc5c2d84660a97f0",
  measurementId: "G-WPBHX3T0WG"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const db = app.database();

export { firebase, db };
export default firebase;
